import { useState } from "react";
import { Link } from "react-router-dom";
import { colors } from "../../colors";
import BandeauSvg from "./BandeauSvg";
import "./bgImgTop.css";

const SUBTITLE_LIMIT = 250;

const BgImgTop = ({ image, linkBtn, title, subtitle, bandeau, avis, ctaButtons }) => {
	const [expanded, setExpanded] = useState(false);
	const isLong = subtitle && subtitle.length > SUBTITLE_LIMIT;
	const displayedSubtitle = isLong && !expanded
		? subtitle.slice(0, SUBTITLE_LIMIT) + "…"
		: subtitle;

	return (
		<div
			id="intro"
			style={{
				height: "100vh",
				backgroundImage: `url(${image})`,
				backgroundSize: "cover",
				backgroundPosition: "top",
			}}
			className="bg-image shadow-2-strong relative"
		>
			<div
				className="mask"
				style={{
					backgroundColor: "rgba(0, 0, 0, 0.4)",
					height: "100%",
				}}
			>
				<div
					style={{
						height: "100%",
						paddingTop: "100px",
					}}
					className="container d-flex align-items-center justify-content-center text-center h-100"
				>
					<div className="text-white">
						<h1 className="mb-3 titleBgImgTop ">{title}</h1>
						{subtitle && (
							<div className="mb-4">
								<h5 className="subtitleBgImgTop">
									{displayedSubtitle}
								</h5>
								{isLong && (
									<button
										className="subtitle-toggle-btn"
										onClick={() => setExpanded(!expanded)}
									>
										{expanded ? "Voir moins" : "Lire la suite"}
									</button>
								)}
							</div>
						)}
						<div className="d-flex justify-content-center align-items-center flex-wrap gap-2">
							{linkBtn && (
								<a
									target={"_blank"}
									rel="noreferrer"
									href={`${linkBtn}`}
									className="btn-custom rose m-r-5 "
								>
									Vidéo Youtube
								</a>
							)}
							{avis && (
								<a
									target={"_blank"}
									rel="noreferrer"
									href={`${avis}`}
									className="btn-custom violet "
								>
									VOIR LES AVIS
								</a>
							)}
							{ctaButtons && ctaButtons.map((btn, i) => (
								<Link
									key={i}
									to={btn.to}
									className={`btn-custom ${btn.variant || "rose"}`}
								>
									{btn.label}
								</Link>
							))}
						</div>
					</div>
				</div>
			</div>
			{bandeau && (
				<>
					<div
						className="bandeauBgImg "
						style={{ borderBottom: `4px solid white ` }}
					>
						<BandeauSvg color={"white"} />
					</div>
					<div className="bandeauBgImg secondBgImg">
						<BandeauSvg color={colors.violetFonce} />
					</div>
				</>
			)}
		</div>
	);
};

export default BgImgTop;
